import { Component } from '@angular/core';
import { BcMessagesManager } from '../../../widgets';


@Component({
  selector: 'bc-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  constructor(public bcMessagesManager: BcMessagesManager) {}
}
